import React from "react";
import { ReactComponent as AttachIcon } from "../../assets/img/common/attach-icon.svg";
import { Oval } from "react-loader-spinner";
import { IoCloseOutline } from "react-icons/io5";
const AttachFileField = ({
  containerClass = "w-40  ",
  inputClass = "h-12",
  id,
  onChange,
  value,
  title,
  placeholder,
  disabled = false,
  formik,
  onBlur = () => {},
  description = "",
  isLoading,
  // required,
}) => {
  const error = () => {
    if (formik && formik.touched?.[id] && formik.errors?.[id]) return true;
    else return false;
  };
  return (
    <label
      htmlFor={id}
      className={`${containerClass} flex flex-col font-roboto cursor-pointer`}
    >
      <div className=" pl-2">
        <h3 className="font-bold mb-1 text-sm">{title}</h3>
        {description && <p className="text-xs mb-1">{description}</p>}
      </div>

      <div
        className={`w-full flex items-center justify-between rounded-[10px] text-sm font-[poppins] px-4 ${
          error()
            ? " border-2 border-red-500"
            : " border border-custom-gray-600"
        }  ${inputClass} `}
      >
        {value ? (
          <div className="max-w-[90%] py-1.5 px-3 flex justify-between rounded-full bg-primary text-white">
            <span className="max-w-fit truncate">
              {value.substring(value.lastIndexOf("/") + 1)}
            </span>
            <button
              type="button"
              onClick={() => formik?.setFieldValue(id, "")}
              className="w-5 h-5 rounded-full flex justify-center items-center bg-[#734be16d] ml-1.5"
            >
              <IoCloseOutline color="white" />
            </button>
          </div>
        ) : (
          <span className="text-[#9ca3af] truncate">{placeholder}</span>
        )}
        {isLoading ? (
          <Oval
            height={25}
            width={25}
            color="#8538FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#8538FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        ) : (
          // <label htmlFor={id} className="cursor-pointer">
          <AttachIcon className="pointer-events-none" />
          // </label>
        )}
        <input
          type={"file"}
          onBlur={onBlur}
          onChange={onChange}
          disabled={disabled}
          className={`hidden`}
          id={id}
          accept="application/pdf"
        />
      </div>

      {error() && (
        <span className="text-red-500 text-sm mt-1">{formik.errors?.[id]}</span>
      )}
    </label>
  );
};

export default AttachFileField;
